// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  box-sizing: border-box;
  font-family: inherit;
}

.a11y-only {
  position: absolute !important;
  display: block !important;
  height: 1px !important;
  max-height: 1px !important;
  width: 1px !important;
  max-width: 1px !important;
  clip: rect(1px, 1px, 1px, 1px) !important;
  overflow: hidden !important;
  opacity: 0.000001 !important;
}
`, "",{"version":3,"sources":["webpack://./src/theme/reset.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,sBAAsB;EACtB,0BAA0B;EAC1B,qBAAqB;EACrB,yBAAyB;EACzB,yCAAyC;EACzC,2BAA2B;EAC3B,4BAA4B;AAC9B","sourcesContent":["* {\n  box-sizing: border-box;\n  font-family: inherit;\n}\n\n.a11y-only {\n  position: absolute !important;\n  display: block !important;\n  height: 1px !important;\n  max-height: 1px !important;\n  width: 1px !important;\n  max-width: 1px !important;\n  clip: rect(1px, 1px, 1px, 1px) !important;\n  overflow: hidden !important;\n  opacity: 0.000001 !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
